import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  getAlertsError,
  getAlertsSuccess,
  removeCertificateError,
  removeCertificateSuccess,
  updAlertsError,
  updAlertsSuccess,
} from './actions'
import {
  ALERTS_SETTINGS_REQUEST_ASYNC,
  REMOVE_CERTIFICATE_REQUEST_ASYNC,
  UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC,
} from './constants'

const getAlertsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      ALERTS_SETTINGS_REQUEST_ASYNC.INITIATE,
      UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.alerts)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getAlertsSettings(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getAlertsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getAlertsError, error)))
        .takeUntil(action$.ofType(ALERTS_SETTINGS_REQUEST_ASYNC.CANCEL))
    )

const updAlertsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .updAlertsSettings(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.data
      )
      .map(() => updAlertsSuccess(action.payload.data))
      .catch((error) => Observable.of(epicsErrorHandler(updAlertsError, error)))
      .takeUntil(action$.ofType(UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

const removeCertificateEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(REMOVE_CERTIFICATE_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .removeCertificate(store.getState().partnerOptions.selectedCompany?.value)
      .mergeMap(() =>
        Observable.of(
          removeCertificateSuccess(),
          addToast({ type: 'success', message: 'Certificate removed' })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(removeCertificateError, error),
          addToast({ type: 'error', message: 'Action failed' })
        )
      )
      .takeUntil(action$.ofType(REMOVE_CERTIFICATE_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(getAlertsEpic, updAlertsEpic, removeCertificateEpic)
